/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAnd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10.974 20c.962 0 1.805-.148 2.53-.444a5.952 5.952 0 0 0 1.88-1.204l1.254 1.41H19l-2.529-2.84c.488-.868.836-1.843 1.045-2.927.21-1.084.314-2.183.314-3.296v-.629h-3.407v.911l1.755.564v.065c0 .708-.07 1.409-.209 2.103a7.308 7.308 0 0 1-.668 1.93l-4.473-5.03a27.35 27.35 0 0 1-1.045-1.28c-.25-.332-.425-.628-.523-.889a2.327 2.327 0 0 1-.146-.823c0-.607.227-1.084.68-1.431.452-.347 1.076-.52 1.87-.52.85 0 1.756.216 2.717.65V4.629a5.5 5.5 0 0 0-1.296-.456A6.338 6.338 0 0 0 11.664 4c-1.338 0-2.404.332-3.198.997S7.275 6.551 7.275 7.664c0 .462.09.918.272 1.366.18.448.501.961.961 1.54l-.146.13C6.787 12.057 6 13.611 6 15.36c0 .882.216 1.673.648 2.374a4.605 4.605 0 0 0 1.776 1.659c.753.405 1.603.607 2.55.607zm.188-1.67c-.989 0-1.783-.292-2.382-.877-.6-.586-.899-1.363-.899-2.331 0-1.272.488-2.342 1.463-3.209l.167-.151 4.745 5.333a4.29 4.29 0 0 1-1.338.9c-.516.224-1.1.336-1.756.336z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAnd as And };
